import { vMaska } from 'maska/vue'
import type { App } from 'vue'

const addMaskaDirective = (app: App<Element>) => {
  app.directive('maska', vMaska)
}

export default addMaskaDirective
